export default __webpack_public_path__ + "static/superheroes-430f48b26a958013119e1229646264d9.png";